/**
 * @deprecated
 * This file is preserved for backwards compatability, but future users should import from:
 * - integrations/shopify
 * - integration/utils
 * */

import { waitForElement } from "../../utils/wait-for-element";
import { getCookieMap, getCookieValue } from "../../utils/cookies";

const utils = {
  waitForElement,
  getCookieMap,
  getCookieValue,
};

export { utils };
export { initNetworkListeners } from "../../utils/network-listeners";
export * as events from "../../utils/events";

export * from "../../integrations/shopify";
